// Generated from the approved MagicPath revision 440525496078450688. Do not hand-edit; update the source worktree instead.
import { useState } from 'react';
const bubblePlate = "/assets/page06-house45.jpg";
const navigation = ['METHOD', 'HOUSE 45', 'INSIGHTS', 'ASSESSMENT'];
const phases = [{
  days: 'BEFORE DAY ONE',
  title: 'STOP THE BLEED',
  body: 'End the live exposure. Establish the truth. Make the immediate environment safe enough to train.'
}, {
  days: 'DAYS 01–07',
  title: 'COMMAND',
  body: 'Close the exits. Put access, money, and disclosure under hard rules.'
}, {
  days: 'DAYS 08–14',
  title: 'ATTENTION',
  body: 'Take your mind back. Learn to catch the loop before it becomes action.'
}, {
  days: 'DAYS 15–21',
  title: 'RISK ENGINE',
  body: 'Name what the behavior has been doing for you—and what it has been taking.'
}, {
  days: 'DAYS 22–30',
  title: 'REDIRECTION',
  body: 'Build real stakes that pay you back: body, business, family, competition, creation.'
}, {
  days: 'DAYS 31–38',
  title: 'PERFORMANCE',
  body: 'Test the system under pressure. Rehearse the hours, places, and decisions that used to own you.'
}, {
  days: 'DAYS 39–45',
  title: 'BECOME THE HOUSE',
  body: 'Leave with rules that hold, a ninety-day target, and a life built to keep the edge.'
}];
export const Page06WhatHouse45Is = () => {
  const [activeNav, setActiveNav] = useState('HOUSE 45');
  const [activePhase, setActivePhase] = useState(1);
  const phase = phases[activePhase];
  return <main className="house452-page">
    <img className="house452-photo" src={bubblePlate} alt="A column of bubbles rising toward light at the ocean surface" />
    <div className="house452-grade" aria-hidden="true" />
    <button className="house452-wordmark" type="button" aria-label="IMTHEHOUSE home">IMTHEHOUSE</button>
    <nav className="house452-navigation" aria-label="Primary navigation">
      {navigation.map(item => <button type="button" key={item} className={activeNav === item ? 'active' : ''} onClick={() => setActiveNav(item)} aria-pressed={activeNav === item}>{item}</button>)}
    </nav>
    <section className="house452-copy" aria-labelledby="house452-heading">
      <p className="house452-eyebrow">WHAT HOUSE 45 IS</p>
      <h1 id="house452-heading">45 DAYS.<br />ONE COACH.<br /><span>YOUR SIDE OF THE TABLE.</span></h1>
      <p className="house452-kicker">NOT CONTENT TO WATCH.<br />NOT A WORKBOOK TO HIDE BEHIND.</p>
      <p className="house452-intro">Private coaching. Daily contact. Hard rules. Reps under pressure.</p>
      <p className="house452-close">YOU DO NOT LEAVE MOTIVATED.<br /><strong>YOU LEAVE TRAINED.</strong></p>
    </section>
    <section className="house452-system" aria-label="The House 45 operating cycle">
      <div className="house452-phase-list" role="tablist" aria-label="House 45 phases">
        {phases.map((item, index) => <button type="button" role="tab" key={item.title} className={activePhase === index ? 'active' : ''} onClick={() => setActivePhase(index)} onMouseEnter={() => setActivePhase(index)} onFocus={() => setActivePhase(index)} aria-selected={activePhase === index} aria-controls="house452-phase-detail"><i aria-hidden="true" /><span><small>{item.days}</small><strong>{item.title}</strong></span></button>)}
      </div>
      <div className="house452-phase-detail" id="house452-phase-detail" role="tabpanel"><small>{phase.days}</small><h2>{phase.title}</h2><p>{phase.body}</p></div>
      <div className="house452-proof" aria-label="What leaves with you">{['NO HIDDEN ACCESS', 'MONEY UNDER RULES', 'PRESSURE REHEARSED', 'REAL STAKES SCHEDULED', 'NEXT 90 DAYS BUILT'].map(item => <span key={item}>{item}</span>)}</div>
    </section>
  </main>;
};